import React from 'react'
import styled from 'styled-components'
import PageHeaderImage from '../../components/pageHeaderImage'

const Header = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
`

const PostHero = ({ content }) => {
	content.pageHeaderImage = content['heroImage']
	content.pageHeaderImageMobile = content['heroImageMobile']
		? content['heroImageMobile']
		: content['heroImage']

	return (
		<Header>
			<PageHeaderImage content={content} isPost={true} />
		</Header>
	)
}

export default PostHero
